import { Table } from 'antd';
import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import { FormErrorMessage } from './form-elements';

export const GridTable = styled(Table)<{ isDisabled: boolean }>`
  .ant-table table {
    border-spacing: 0 var(--spacing-03);
    border-collapse: separate;
    opacity: ${(props) => (props.isDisabled ? '0.5' : '1')};
    pointer-events: ${(props) => (props.isDisabled ? 'none' : 'default')};
  }

  .ant-table-content {
    cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'default')};
  }

  .ant-table-pagination {
    display: none;
  }

  .ant-table-cell.ant-table-selection-column {
    border-spacing: initial;
  }

  .ant-table-thead > tr > th {
    border: none;
    background-color: var(--white-100);
    text-align: center;
  }

  .ant-table-cell-fix-left {
    text-align: left !important;
  }

  .ant-table-tbody > tr > td {
    border: none;
    text-align: center;
    background-color: var(--coolest-gray-10);
    margin: 1rem;
    padding: var(--spacing-04);
    border-radius: 3px;
    justify-content: center;
    margin: auto;
  }

  .ant-table-tbody > tr > td .ant-checkbox-wrapper {
    justify-content: center;
  }

  .ant-table-tbody > tr > td .ant-checkbox-checked .ant-checkbox-inner::after {
    transform: rotate(45deg) scale(0.7) translate(-50%, -50%);
    top: 24%;
    left: 7.3%;
    width: 8px;
    border-right-width: 3px;
    border-bottom-width: 3px;
  }

  .ant-table-tbody > tr > td .ant-radio-wrapper {
    justify-content: center;
  }

  .ant-table-tbody > tr > td .ant-radio-checked .ant-radio-inner::after {
    display: block;
  }
`;

export const RowInputError = () => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    ref?.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }, []);

  return (
    <div ref={ref}>
      <FormErrorMessage errorMessageKey="row.input.required" />
    </div>
  );
};

export const getGridColumns = (fieldItem) => {
  return [
    {
      title: '',
      dataIndex: 'rowName',
      key: 'rowName',
      width: 150,
      fixed: true,
    },
    ...(fieldItem?.options?.map((option) => ({
      title: option.optionLabel,
      dataIndex: option.optionLabel,
      key: option.optionId,
    })) || []),
  ];
};

export const getGridColumnNames = (gridColumns) =>
  gridColumns.map((item) => ({
    title: item.title,
    key: item.key,
  }));
